import React, { useEffect, useState } from 'react';
import { Breadcrumb, Layout, theme, Row, Col, Form, Button, Modal, Select, Input, Spin ,Image, Typography, Table, Card, Tag, Space, Switch, Tooltip, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { useNavigate } from "react-router-dom";
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../usableclasses.js';
const { Content } = Layout;
const { Option } = Select;
const { Title, Text } = Typography;


function ProductTypes() {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

   
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [ProductTypes, setProductTypes] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editProductType, setEditProductType] = useState(null);
    const [filteredProductTypes, setFilteredProductTypes] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [selectedProductType, setSelectedProductType] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchProductTypes();
    }, []);

    const fetchProductTypes = async () => {
        setLoading(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/master/Productstype/all`, { headers });
            setProductTypes(response.data);
            setFilteredProductTypes(response.data);
        } catch (error) {
            AlertError("Failed to fetch Product Types");
        } finally {
            setLoading(false);
        }
    };

 
    const showModal = () => {
        setIsModalOpen(true);
    };
    const showEditModal = (ProductType) => {
     
        setEditProductType(ProductType);
        form.setFieldsValue({
           // ProductTypeCode: ProductType.ProductTypeCode,
            ProductTypeName: ProductType.productTypeName,
            ProductTypeActiveStatus: ProductType.productTypeActiveStatus === true,
        });
        setIsEditModalOpen(true);
    };
    
    const handleCancel = () => {
        setIsModalOpen(false);
        setIsEditModalOpen(false);
        form.resetFields();
    };

    
    const handleCreateProductType = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();

            const requestData = {
                ProductTypeName: values.ProductTypeName,
            };

            const headers = {
                SystemAccessToken: TOKEN,
                "Content-Type": "application/json",
            };

            const response = await axios.post(
                `${ApiURL}/master/productstype/create`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Product Type successfully added!");
                handleCancel();
                fetchProductTypes();
            }
        } catch (error) {
            AlertError(error.response?.data?.message || "Failed to add Product Type!");
        }finally {
            setLoading(false);
        }
    };
    const handleUpdateProductType = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();
            const requestData = {
              ProductTypeId: editProductType.productTypeId,
              ProductTypeName: values.ProductTypeName,
              ProductTypeActiveStatus: values.ProductTypeActiveStatus,
            };

            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.post(
                `${ApiURL}/master/productstype/edit`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Product Type successfully updated!");
                handleCancel();
                fetchProductTypes();
            }
        } catch (error) {
            AlertError(error.response?.data?.message || "Failed to update Product Type!");
        }finally {
            setLoading(false);
        }
    };

    const handleDeleteProductType = async (id) => {
        setLoading(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            await axios.get(`${ApiURL}/master/Productstype/delete/${id}`, { headers });
            AlertSuccess("Product Type deleted successfully!");
            fetchProductTypes();
        } catch (error) {
            AlertError("Failed to delete Product Type!");
        }finally {
            setLoading(false);
        }
    };

    const handleFilter = () => {
        setLoading(true);
        let filtered = ProductTypes;

        if (selectedProductType) {
            filtered = filtered.filter(ProductType => ProductType.ProductTypeId === selectedProductType);
        }

        if (keyword) {
            filtered = filtered.filter(ProductType => ProductType.ProductTypeName.toLowerCase().includes(keyword.toLowerCase()));
        }

        setFilteredProductTypes(filtered);
       
     setLoading(false);
        
    };

   
    const handleReset = () => {
        setLoading(true);
        setKeyword('');
        setSelectedProductType(null);
        setFilteredProductTypes(ProductTypes);
        setLoading(false);
    };
    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            fixed: 'left',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button type="link" icon={<EditOutlined />} onClick={() => showEditModal(record)} />
                    </Tooltip>
                    <Popconfirm
                        title="Are you sure to delete this Product Type?"
                        onConfirm={() => handleDeleteProductType(record.productTypeId)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip title="Delete">
                            <Button type="link" danger icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            ),
        },
        {
            title: 'Product Type Name',
            dataIndex: 'productTypeName',
            key: 'productTypeName',
            sorter: (a, b) => a.productTypeName.localeCompare(b.productTypeName),
            align: "center",
        },
        {
            title: 'Status',
            dataIndex: 'productTypeActiveStatus',
            key: 'productTypeActiveStatus',
            render: (productTypeActiveStatus) => (
                <Tag color={productTypeActiveStatus === true ? "green" : "red"}>
                    {productTypeActiveStatus === true ? "Active" : "Inactive"}
                </Tag>
            ),
            align: "center",
        },
    ];
    return (
        <Spin spinning={loading} tip="Processing...">
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: '10px', }} >
                <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item>Master</Breadcrumb.Item>
                    <Breadcrumb.Item>Product Types</Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG, }} >
                    <Space
                        direction="vertical"
                        style={{ width: "100%", padding: "15px" }}
                    >
                        <Row>
                            <Col xs={24} style={{ textAlign: "right",marginBottom:'10px' }}>
                                <Button type="primary" onClick={showModal}>Create New</Button>
                            </Col>

                        </Row>
                        
                        <Typography.Title level={5}>List of Product Types</Typography.Title>
                        <Table
                            columns={columns}
                            dataSource={filteredProductTypes}
                            rowKey="ProductTypeId"
                            pagination={{ pageSize: 5 }}
                            scroll={{ x: 600 }}
                        />

                    </Space>
                </div>
            </Content>
            <Footerdiv />
            <Modal
                title="Create New Product Type"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="create" type="primary" onClick={handleCreateProductType}>
                        Create
                    </Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    {/* <Form.Item
                        label="ProductType Code"
                        name="ProductTypeCode"
                        rules={[
                            { required: true, message: "ProductType code is required" },
                            { len: 4, message: "ProductType code must be exactly 4 characters" },
                        ]}
                    >
                        <Input maxLength={4} />
                    </Form.Item> */}

                    <Form.Item
                        label="Product Type Name"
                        name="ProductTypeName"
                        rules={[{ required: true, message: "Product Type name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Edit Product Type"
                open={isEditModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                    <Button key="update" type="primary" onClick={handleUpdateProductType}>Update</Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    {/* <Form.Item
                        label="ProductType Code"
                        name="ProductTypeCode"
                        rules={[{ required: true, message: "ProductType code is required" }, { len: 4, message: "ProductType code must be exactly 4 characters" }]}
                    >
                        <Input maxLength={4} />
                    </Form.Item> */}
                    <Form.Item
                        label="Product Type Name"
                        name="ProductTypeName"
                        rules={[{ required: true, message: "Product Type name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Active Status"
                        name="ProductTypeActiveStatus"
                        valuePropName="checked"
                    >
                        <Switch defaultChecked={editProductType?.ProductTypeActiveStatus === true} />
                    </Form.Item>
                </Form>
            </Modal>
            
        </Layout>
        </Spin>
    );
}

export default ProductTypes;